// apps/admin/src/main.tsx
import { createRoot } from "react-dom/client";
import "leaflet/dist/leaflet.css";
import "./index.css";
import { AppRouter } from "./router";
import { ErrorBoundary } from "@yogo/ui";
import ServerErrorPage from "./pages/ServerErrorPage";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

createRoot(root).render(
  <ErrorBoundary fallback={<ServerErrorPage />}>
    <AppRouter />
  </ErrorBoundary>,
);

// Day 59 complete
